import { render, staticRenderFns } from "./BaseContextMenu.vue?vue&type=template&id=5aa44f86&scoped=true&"
import script from "./BaseContextMenu.vue?vue&type=script&lang=js&"
export * from "./BaseContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./BaseContextMenu.vue?vue&type=style&index=0&id=5aa44f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa44f86",
  null
  
)

export default component.exports